import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { RealtyFilterArea } from './fields/realty-filter-area';
import { RealtyFilterLocation } from './fields/realty-filter-location';
import { RealtyFilterNewBuildingsOnly } from './fields/realty-filter-new-buildings-only';
import { RealtyFilterNumberOfRooms } from './fields/realty-filter-number-of-rooms';
import { RealtyFilterPrice } from './fields/realty-filter-price';
import { RealtyFilterRealtyOfferType } from './fields/realty-filter-realty-offer-type';
import styles from './realty-filter.module.css';
import type {
  RealtyFilterVariant,
  UnderConstructionSearchCapability,
} from './realty-filter-recipe';

export type RealtyFilterProps = {
  className?: string;
  variant?: RealtyFilterVariant;
  underConstructionSearchCapability?: UnderConstructionSearchCapability;
};

export const RealtyFilter = ({
  className,
  variant = 'desktop',
  underConstructionSearchCapability = 'unavailable',
}: RealtyFilterProps) => {
  const categorySettings = useGlobalStore(state => state.templateSettings?.realty_category);
  const offerTypeSetting =
    categorySettings?.offer_type_in_filter ?? categorySettings?.realty_type_in_filter;

  return (
    <div
      className={cn(styles.filter, className)}
      data-eli-part="realty-filter-fields"
      data-variant={variant}
    >
      {offerTypeSetting?.enabled && (
        <RealtyFilterRealtyOfferType templateSetting={offerTypeSetting} />
      )}
      {categorySettings?.price_in_filter?.enabled && (
        <RealtyFilterPrice templateSetting={categorySettings.price_in_filter} />
      )}
      {categorySettings?.location_in_filter?.enabled && (
        <RealtyFilterLocation
          templateSetting={categorySettings.location_in_filter}
          variant={variant}
        />
      )}
      {categorySettings?.number_of_rooms_in_filter?.enabled && (
        <RealtyFilterNumberOfRooms templateSetting={categorySettings.number_of_rooms_in_filter} />
      )}
      {categorySettings?.only_new_building_in_filter?.enabled && (
        <RealtyFilterNewBuildingsOnly
          templateSetting={categorySettings.only_new_building_in_filter}
          searchCapability={underConstructionSearchCapability}
        />
      )}
      {categorySettings?.area_in_filter?.enabled && (
        <RealtyFilterArea templateSetting={categorySettings.area_in_filter} />
      )}
    </div>
  );
};
